import { Link } from "react-router-dom"
import { ActiveSiteLink } from "../services/webb-utilities"

import icon from '../media/icon.png'
import avtr from '../media/user.png'

import { GetAuthUser } from "../services/user-accounts"

export default function HeaderMain() {

  const asset = GetAuthUser();

  var list = []
  if (asset.form === "us") list = require('../data/navs-user-main.json').data;
  if (asset.form === "bz") list = require('../data/navs-bsnx-main.json').data;

  return (
    <>
    <div className="sticky-top border-bottom bg-white">
    <div className="container">
      <div className="row">
        <div className="col-lg-1 d-none d-lg-block"></div>
        <div className="col">
          <div className="d-flex justify-content-between py-2">
            <div className="py-2">
              <img 
                src={icon} 
                width="33" height="33" alt="..."
                className=""
              ></img>
            </div>
            <div className="py-1">
              <nav className="nav nav-pill">
                {list && list.map((item, i) => (item.actv ?
                  <Link 
                    to={`/${item.link}`} key={i}
                    className={`nav-link m-0 px-2
                    ${ActiveSiteLink()===item.link ? 'active': 'text-muted'}`}
                  >{item.name}</Link>  
                
                :''))}
              </nav>

            </div>

            <div className="">
            <Link to={asset.form === 'us' ? "/settings" : '/bz/settings'} className="nav-link active">
              <img 
                src={avtr} 
                width="30" height="30" alt="..."
                className="shadow-sm rounded-circle"
              ></img>
            </Link>
            </div>
          </div>

        </div>
        <div className="col-lg-1 d-none d-lg-block"></div>
      </div>
      </div>  
    </div>
    
    </>
  )
}